import { createContext } from 'react';
import store from '../../store';

import transferPropertiesToComponent from '../../page-components/ComponentData/transferPropertiesToComponent';

export const PageDataContext = createContext<any | null>(null);

export const getProjectDataFromContext = (context: any) => {
  const templatesConfig = store.getState().templatesConfig;

  try {
    let retData = null;

    switch (context.pageType) {
      case 'popups':
        retData = JSON.parse(templatesConfig.popups[context.pageId].projectData);
        break;
      case 'components': {
        const componentId = context.pageId;
        const projectData = templatesConfig.components[componentId].projectData;

        const setComponentsDefaultsValue =
          templatesConfig.setComponentsDefaults[componentId] != null
            ? templatesConfig.setComponentsDefaults[componentId]
            : {};

        const data = JSON.parse(projectData);

        if (setComponentsDefaultsValue && Object.keys(setComponentsDefaultsValue).length)
          transferPropertiesToComponent(data, setComponentsDefaultsValue);

        if (context?.pageProperties?.['-reLinkNodes-']) {
          const rln = context.pageProperties['-reLinkNodes-'];
          Object.keys(rln ?? {}).forEach((key) => {
            if (rln[key] && data?.[key]) {
              const links = data[key].props?.properties?.links ?? {};
              if (!data[key].props) {
                data[key].props = { properties: {} };
              } else if (!data[key].props.properties) {
                data[key].props.properties = {};
              }
              data[key].props.properties.links = {
                ...links,
                ...rln[key],
              };
            }
          });
        }

        retData = data;
        break;
      }
      case 'componentsDataRef': {
        const componentDataId = context.pageId;
        const componentId = context.pageLayoutId;

        const projectData = templatesConfig.components[componentId].projectData;
        const cdProperties =
          templatesConfig.componentsData[componentDataId] != null
            ? templatesConfig.componentsData[componentDataId]
            : {};

        const setCompontsDefaultsValue =
          templatesConfig.setComponentsDefaults[componentId] != null
            ? templatesConfig.setComponentsDefaults[componentId]
            : {};

        const visualIdentity =
          templatesConfig.setComponentsDataDefaults[`${componentId}|${componentDataId}`] != null
            ? templatesConfig.setComponentsDataDefaults[`${componentId}|${componentDataId}`]
            : {};

        const finalCDProperties = { ...cdProperties, ...visualIdentity };

        const data = JSON.parse(projectData);

        //console.log(`setCompontsDefaults[${componentId}]`, setCompontsDefaults);

        if (setCompontsDefaultsValue && Object.keys(setCompontsDefaultsValue).length)
          transferPropertiesToComponent(data, setCompontsDefaultsValue);
        if (finalCDProperties && Object.keys(finalCDProperties).length)
          transferPropertiesToComponent(data, finalCDProperties);

        retData = data;
        break;
      }
      case 'componentsElements':
        retData = JSON.parse(templatesConfig.componentsElements[context.pageId].projectData);
        break;
      case 'page':
        retData = JSON.parse(templatesConfig.pages[context.pageId].projectData);
        break;
      case 'layout':
        retData = JSON.parse(templatesConfig.pageLayouts[context.pageLayoutId].projectData);
        break;
      default:
        console.error('[getProjectDataFromContext] Unknown page type', context.pageType);
        retData = null;
        break;
    }

    if (context?.overrideId && retData) {
      if (context.pageType === 'page') {
        const pageLayoutsOverrides = templatesConfig.pagesOverrides;
        const overrides = pageLayoutsOverrides[context.overrideId];
        if (overrides && Object.keys(overrides).length) {
          transferPropertiesToComponent(retData, overrides);
        }
      } else if (context.pageType === 'layout') {
        const pageLayoutsOverrides = templatesConfig.pageLayoutsOverrides;
        const overrides = pageLayoutsOverrides[context.overrideId];
        if (overrides && Object.keys(overrides).length) {
          transferPropertiesToComponent(retData, overrides, true, false, true);
        }
      }
    }

    return retData;
  } catch (e) {
    console.error('[getProjectDataFromContext] err', e);
    return null;
  }
};
